/**
 * @generated SignedSource<<f59f90b705de12d136eb6c05b5834029>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RolePicker_data$data = {
  readonly jira: {
    readonly isGlobalAdmin: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "RolePicker_data";
};
export type RolePicker_data$key = {
  readonly " $data"?: RolePicker_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RolePicker_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "RolePicker_data",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "alias": "isGlobalAdmin",
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Literal",
              "name": "key",
              "value": "ADMINISTER"
            }
          ],
          "kind": "ScalarField",
          "name": "hasGlobalPermission"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "52737bdaec8485d25a9ee0d306abfe16";

export default node;
